<template>
  <section>
    <h4>華藏教學園區園區工作人員</h4>
    <h5>工作性質：</h5>
    <p>協助各項教學共修活動之進行，園區之安全維護、環境整理等。</p>
    <h5>工作地點：</h5>
    <p>華藏教學園區(新北市深坑區阿柔里5鄰大崙尾9號)</p>
    <h5>資格：</h5>
    <p>
      1.願發心在佛教界工作，能與大眾和合相處，已受三皈，具正知見，長期素食之三寶弟子。<br>
      2.品行端正，配合度高，負責盡職，身心健全，具服務熱忱，發心修福修慧。(男眾，須役畢)<br>
      3.基本電腦操作為佳。<br>
      4.備有汽機車駕照為佳。<br>
      5.須能配合在園區輪值住宿留守。
    </p>
    <h5>待遇：</h5>
    <p>
      1.薪資優於法定基本工資。<br>
      2.每月發給工作津貼。<br>
      3.依年度表現，發給年終獎金、年資薪。<br>
      4.提供伙食及住宿。<br>
      5.在本會加保勞健保。
    </p>
    <h5>應徵方式：</h5>
    <p>
      有意應徵者，<br>
      敬請備妥履歷、照片及中文自傳，詳述學佛歷程，<br>
      以函寄、E-mail或面交：<br>
      「台北市杭州南路一段55號3樓」華藏教學園區　收<br>
      電話：<a href="tel:+886-2-23951198">{{ $i18n.locale === 'tw' ? '0' : '+886-' }}2-23951198</a>轉分機12 園長<br>
      傳真：(02)2391-3415<br>
      Email：<a href="mailto:joehuang@budaedu.org">joehuang@budaedu.org</a>；<a href="mailto:joehuang1015@gmail.com">joehuang1015@gmail.com</a>
    </p>
    <p>
      ※ <span style="color: red; font-weight: bold;">煩請投遞履歷後，請來電與園長確認</span>。<br>
      ※ 經本會審核後，另行約定面試時間；不適者，恕不退件。
    </p>
  </section>
</template>
<script>
import Vue from 'vue'

import i18n from '@/plugins/i18n.js'

export default {
  i18n,
  name: "hwadzan-garden-staff",
  props: {
    // 
  },
  data() {
    return {
      // 
    }
  },
  methods: {
    // 
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
  },
  components: {
    // 
  }
}
</script>